import { packItemTypeIDEnum } from "#/components/educationPack/chapter/lessonList/type";
import DescriptiveAnswer from "#/components/exam-results/descriptiveAnswerTab";
import layoutStyles from "#/components/exam-results/Layout/styles.module.scss";
import { type Tab } from "#/components/exam-results/types";
import {
  useMontaNavigate,
  useParams,
  useSearchParams
} from "@monta/router-react";
import clsx from "clsx";
import OverallInfoTab from "./overall";

const ExamResultsPackagesView = () => {
  const params = useParams();
  const [searchparams] = useSearchParams();
  const navigate = useMontaNavigate();
  const packItemTypeID = Number(searchparams.get("packItemTypeID"));
  const examTakingId = Number(params["examTakingId"]);

  const selectedTab =
    Number(params?.["tabId"]) === 1 && packItemTypeID === 1
      ? 2
      : Number(params?.["tabId"]);

  const tabs: Tab[] = [
    ...(packItemTypeID !== packItemTypeIDEnum.PRACTICE
      ? [
          {
            title: "اطلاعات کلی",
            id: 1,
            component: <OverallInfoTab />
          }
        ]
      : []),
    {
      title: "جواب تشریحی",
      id: 2,
      component: <DescriptiveAnswer />
    }
  ];

  return (
    <>
      <div className={layoutStyles["examResultsLayout__tabs"]}>
        {tabs.map((tab) => {
          return (
            <button
              key={tab.id + "btn"}
              className={clsx(
                selectedTab === tab.id &&
                  layoutStyles["examResultsLayout__tabs--active"]
              )}
              onClick={() => {
                navigate(`/exam-results/package/${tab.id}/${examTakingId}`, {
                  replace: true
                });
              }}
            >
              {tab.title}
            </button>
          );
        })}
      </div>

      <div className={layoutStyles["examResultsLayout__content"]}>
        {(tabs[selectedTab - 1] ?? tabs[0]).component}
      </div>
    </>
  );
};

export default ExamResultsPackagesView;
